import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStoredUser } from '../../helpers/user-storage.util';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from '../../shared/modal/modal.component';

@Component({
  selector: 'opt-in-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    ReactiveFormsModule,
    ModalComponent,
  ],
  templateUrl: './opt-in-dialog.component.html',
  styleUrl: './opt-in-dialog.component.scss',
})
export class OptInDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Output() handleOptIn = new EventEmitter<any>();
  @Output() modalClosed = new EventEmitter<boolean>();

  user = getStoredUser();
  isSubmitting = false;
  phoneFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.phoneFormGroup = this.formBuilder.group({
      selectedPhone: this.user.phone,
    });
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.isSubmitting = true;
    // Re-read the cached user here rather than relying on the field initializer's
    // snapshot: this component is created once when Settings mounts and never
    // torn down, so `this.user` can be stale (and its `version` behind) by the
    // time the vendor confirms. Phone selection still uses the snapshot the
    // dialog was opened with — the numbers themselves don't change mid-dialog.
    const currentUser = getStoredUser();
    if (this.user.phone && this.user.phone2) {
      if (this.phoneFormGroup.value.selectedPhone === this.user.phone) {
        this.user = {
          ...currentUser,
          usePhoneForSms: true,
          usePhone2ForSms: false, // will reset if previous error
        };
      } else if (this.phoneFormGroup.value.selectedPhone === this.user.phone2) {
        this.user = {
          ...currentUser,
          usePhoneForSms: false,
          usePhone2ForSms: true,
        };
      } else {
        // Neither phone matched the selection — still emit on the freshly-read
        // user so the version carried isn't a stale snapshot.
        this.user = { ...currentUser };
      }
    } else if (this.user.phone) {
      this.user = {
        ...currentUser,
        usePhoneForSms: true,
        usePhone2ForSms: false,
      };
    } else if (this.user.phone2) {
      this.user = {
        ...currentUser,
        usePhoneForSms: false,
        usePhone2ForSms: true,
      };
    } else {
      this.user = { ...currentUser };
    }
    this.handleOptIn.emit(this.user);
  }
}
